import { initializeApp } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";

const JWT_REFRESH_PERIOD_MS = 1000 * 60 * 5; // 5 min
const MESSAGE_SENDING_PERIOD_MS = 200;
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBfTnxIRhZ2cvSI2P9x88b_1r3zomWwVkk",
  authDomain: "plouf-288322.firebaseapp.com",
  databaseURL: "https://plouf-288322.firebaseio.com",
  projectId: "plouf-288322",
  storageBucket: "plouf-288322.firebasestorage.app",
  messagingSenderId: "173010693856",
  appId: "1:173010693856:web:f3e29863bb88cff5b8ea85",
};
const AGE_HEARTBEAT_CONSIDERED_STALE_MS = 60 * 1000; // 1 min

const CLASS_ICON_CONNECTED = "fluent--live-24-filled";
const CLASS_ICON_DISCONNECTED = "fluent--live-off-24-filled";
const CLASS_HEARTBEAT_ANIMATION = "heartbeat";

const API_DISABLED = false;

let ws = null;
let currentJwt = null;
let loginContainerNode = null;
let mainContainerNode = null;
let connectedStatusNode = document.querySelector("#connected");
let openingStatusNode = document.querySelector("#opening");
let closingStatusNode = document.querySelector("#closing");

async function sendApiMessage(method, action, body) {
  if (API_DISABLED) {
    return;
  }

  const response = await fetch(`/api/${action}`, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${currentJwt}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    console.error("Error:", response.statusText);
  }

  return await response.text();
}

function addClassWhenHeld(triggerNode, className, targetNode) {
  if (!targetNode) {
    targetNode = triggerNode;
  }

  // // Needed on Chrome android for some reason to prevent default behavior of long press.
  // triggerNode.addEventListener("touchstart", (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  // });

  triggerNode.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    e.stopPropagation();
    targetNode.classList.add(className);
  });
  triggerNode.addEventListener("pointerup", () => {
    targetNode.classList.remove(className);
  });
  triggerNode.addEventListener("pointerleave", () => {
    targetNode.classList.remove(className);
  });
  triggerNode.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
  });
}

function runTaskRepeatedlyWhenHeld(
  node,
  periodMs,
  runnableWhileHeld,
  runnableWhenStopped,
) {
  let intervalId = null;
  node.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (intervalId !== null) {
      return;
    }
    intervalId = setInterval(runnableWhileHeld, periodMs);
    runnableWhileHeld(); // Run the first time immediately.
  });
  node.addEventListener("pointerup", () => {
    if (intervalId === null) {
      return;
    }
    clearInterval(intervalId);
    intervalId = null;
    runnableWhenStopped && runnableWhenStopped();
  });
  node.addEventListener("pointerleave", () => {
    if (intervalId === null) {
      return;
    }
    clearInterval(intervalId);
    intervalId = null;
    runnableWhenStopped && runnableWhenStopped();
  });
}

let connectedIconTimeoutId = null;

function connectWebSocket() {
  if (ws) {
    ws.close();
  }

  ws = new WebSocket("/api/status");
  ws.onopen = () => {
    console.log("Connected to server");
  };
  // TODO: send a JWT to prove who we are!
  ws.onmessage = (event) => {
    console.log("Message from server:", event.data);

    const parsedData = JSON.parse(event.data);
    const timestampMs = parsedData.timestampMs;
    const isOpenRelayOn = parsedData.openRelayState === 1;
    const isCloseRelayOn = parsedData.closeRelayState === 1;

    // Update UI elements based on the received data.
    openingStatusNode.classList.toggle("hidden", !isOpenRelayOn);
    closingStatusNode.classList.toggle("hidden", !isCloseRelayOn);
    const millisecondsBeforeStale =
      timestampMs + AGE_HEARTBEAT_CONSIDERED_STALE_MS - Date.now();
    if (millisecondsBeforeStale > 0) {
      connectedStatusNode.className = CLASS_ICON_CONNECTED;
      animateHeartbeat(connectedStatusNode);
      if (connectedIconTimeoutId) {
        clearTimeout(connectedIconTimeoutId);
      }
      connectedIconTimeoutId = setTimeout(() => {
        connectedStatusNode.className = CLASS_ICON_DISCONNECTED;
      }, millisecondsBeforeStale);
    } else {
      // Already stale!
      connectedStatusNode.className = CLASS_ICON_DISCONNECTED;
    }
  };
  ws.onclose = () => {
    console.log("Disconnected from server");
  };
}

function disconnectWebSocket() {
  if (ws) {
    ws.close();
    ws = null;
  }
}

function animateHeartbeat(node) {
  node.classList.remove(CLASS_HEARTBEAT_ANIMATION);
  void node.offsetWidth;
  node.classList.add(CLASS_HEARTBEAT_ANIMATION);
}

function init() {
  const app = initializeApp(FIREBASE_CONFIG);
  const auth = getAuth();

  loginContainerNode = document.querySelector("#container-login");
  mainContainerNode = document.querySelector("#container-main");

  // Connect with the status websocket when the tab is visible.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      connectWebSocket();
    } else {
      disconnectWebSocket();
    }
  });
  connectWebSocket();

  // Login button.
  const loginButtonNode = document.querySelector("#login");
  loginButtonNode.addEventListener("click", () => {
    signInWithPopup(auth, new GoogleAuthProvider()).catch((error) => {
      console.log(error);
    });
  });
  addClassWhenHeld(loginButtonNode, "clicked");

  // Open button.
  const openButtonNode = document.querySelector("#open");
  runTaskRepeatedlyWhenHeld(openButtonNode, MESSAGE_SENDING_PERIOD_MS, () => {
    sendApiMessage("POST", "open", { timestampMs: Date.now() });
  });
  addClassWhenHeld(openButtonNode, "clicked");

  // Close button.
  const closeButtonNode = document.querySelector("#close");
  runTaskRepeatedlyWhenHeld(
    closeButtonNode,
    MESSAGE_SENDING_PERIOD_MS,
    () => {
      sendApiMessage("POST", "close", { timestampMs: Date.now() });
    },
    () => {
      sendApiMessage("POST", "stop", { timestampMs: Date.now() });
    },
  );
  addClassWhenHeld(closeButtonNode, "clicked");

  // Dev button.
  addClassWhenHeld(
    document.querySelector("#devButton"),
    "displayFlex",
    document.querySelector("#devStatus"),
  );

  onAuthStateChanged(auth, async (user) => {
    if (user) {
      loginContainerNode.classList.add("hidden");

      const refreshJwt = () => {
        user
          .getIdToken(/* forceRefresh */ true)
          .then((token) => {
            console.log(`refreshJwt() called, jwtToken=${token}`);
            currentJwt = token;
          })
          .catch((error) => {
            console.error("Error refreshing JWT:", error);
          });
      };

      setInterval(refreshJwt, JWT_REFRESH_PERIOD_MS);
      refreshJwt(); // Run first time immediately.
    } else {
      loginContainerNode.classList.remove("hidden");
    }
  });
}

init();
